module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0179.jpg?v=190cccfe";